<template>
    <div>
      <div>
        <div class="btn-group" v-if="payStatus !== 2 && payStatus !== 4">
          <el-button size="mini" type="primary" icon="el-icon-delete" @click="batchDeleteOrder">删除</el-button>
          <el-button size="mini" type="primary" icon="el-icon-present" @click="batchPayOrder">支付</el-button>
        </div>
        <el-table
          :data="tableData"
          size="mini"
          ref="orderTable"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          border
          style="width: 100%">
          <el-table-column
            type="selection"
            width="40">
          </el-table-column>
         <!-- <el-table-column
            fixed
            prop="id"
            label="ID"
            :show-overflow-tooltip="true"
            width="auto">
          </el-table-column>-->
          <el-table-column
            fixed
            prop="applyName"
            label="参保人"
            width="auto">
          </el-table-column>
          <el-table-column
            fixed
            prop="city"
            label="社保定价标准"
            width="auto">
          </el-table-column>
          <el-table-column
            prop="cardinality"
            label="参保基数"
            width="auto">
          </el-table-column>
          <el-table-column
            prop="allCountMoney"
            label="金额"
            width="auto">
          </el-table-column>
          <el-table-column
            prop="createDate"
            label="创建日期"
            width="auto">
            <template slot-scope="scope">
              <span>{{scope.row.createDate | dateFormat("YYYY-MM-DD HH:mm:ss")}}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="auto">
            <template slot-scope="scope">
<!--              <el-button @click="showDetail(scope.row)" type="text" size="small">详情</el-button>-->
              <el-button @click="payOrder(scope.row)" type="text" size="small">支付</el-button>
              <el-button @click="deleteOrder(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
</template>

<script>
import utilService from '../../utils/utilService'
import PayTool from '../PayTool/PayTool'
export default {
  name: 'SocialOrder',
  components: {PayTool},
  props: ['payStatus'],
  data () {
    return {
      qrCodeVisible: false,
      qrCodeUri: '',
      utilService: utilService,
      selectedOrders: [],
      tableData: []
    }
  },
  methods: {
    handleSelectionChange (val) {
      this.selectedOrders = val
    },
    batchDeleteOrder () {
      console.log(this.selectedOrders)
    },
    batchPayOrder () {
      console.log(this.selectedOrders)
      let ids = this.selectedOrders.map(item => item.id).join(',')
      let pays = this.selectedOrders.map(item => parseFloat(item.allCountMoney))
      let totalAmount = 0
      if (!ids) {
        this.$message.warning('请选择待支付的社保单！')
        return false
      }
      pays.forEach(item => { totalAmount += item })
      this.$http.post(this.$api.saveOrderInfo.url, {
        payStatus: 1,
        socialInfoIds: ids,
        subject: '上海仁格社保代缴业务',
        totalAmount: totalAmount
      }).then(_ => {
        if (_ && _.code === 200 && _.data && _.data.qrCode) {
          this.$emit('qrCodeEvent', _.data.qrCode)
        } else if (_ && !_.data.qrCode && _.data.subMsg) {
          this.$message.error(_.data.subMsg)
        }
      })
    },
    showDetail (row) {
    },
    payOrder (row) {
      this.$emit('qrCodeEvent', row)
      this.$http.post(this.$api.saveOrderInfo.url, {
        payStatus: 1,
        socialInfoIds: row.id,
        subject: '上海仁格社保代缴业务',
        totalAmount: parseFloat(row.allCountMoney)
      }).then(_ => {
        if (_ && _.code === 200 && _.data && _.data.qrCode) {
          this.$emit('qrCodeEvent', _.data.qrCode)
        } else if (_ && !_.data.qrCode && _.data.subMsg) {
          this.$message.error(_.data.subMsg)
        }
      })
    },
    deleteOrder (row) {
      this.$confirm('确认删除吗？').then(() => {
        this.$http.delete(this.$api.deleteSecuritInfoById.url, {
          id: row.id
        }).then(_ => {
          if (_ && _.code === 200) {
            this.initData()
            this.$message.success('删除成功！')
          }
        })
      })
    },
    handleCloseQrCode (done) {
      if (this.payRes.payStatusMsg !== '支付成功') {
        this.$confirm('还未支付，是否关闭？')
          .then(_ => {
            this.initData()
            utilService.disConnectMQ()
            done()
          })
          .catch(_ => {})
      } else {
        this.initData()
        done()
      }
    },
    initData () {
      this.$http.get(this.$api.getAllSecuritInfo.url).then(_ => {
        if (_ && _.code === 200) {
          let data = _.data || []
          this.tableData = data.map(item => {
            return {
              id: item.id,
              allCountMoney: (item.allCountMoney / 100).toFixed(2),
              applyName: item.applyName,
              city: item.socialStandardPojo.city,
              createDate: item.createDate,
              cardinality: (item.cardinality / 100).toFixed(2),
              discountablemount: item.discountablemount,
              outTradeNo: item.outTradeNo,
              payStatus: item.payStatus,
              status: item.status
            }
          })
        }
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>

<style scoped>
  .btn-group {
    margin-bottom: 10px;
  }

  .qr-code-box {
    width: 150px;
    height: 150px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/SocialSecurity/SocialOrder.vue